import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-all-transf',
  templateUrl: './all-transf.component.html',
  styleUrls: ['./all-transf.component.scss']
})
export class AllTransfComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
